import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  DocumentResponse,
  DocumentsApiService,
  DocumentsListParams,
} from 'features/document-report/api/documents-api.service';
import qs from 'qs';

import { DocumentQueryKeys } from './query-keys';
const { getAssignedDocument } = DocumentsApiService();

const getUsersQuery = (
  params: any,
  options?: UseQueryOptions<DocumentResponse>,
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<DocumentResponse>;
  options?: UseQueryOptions<DocumentResponse>;
} => ({
  queryKey: DocumentQueryKeys.list(params),
  queryFn: async ({ signal }) =>
    await getAssignedDocument(params, {
      // Use async/await for better readability
      config: {
        signal,
        paramsSerializer: {
          serialize: (queryParams) =>
            qs.stringify(queryParams, {
              arrayFormat: 'repeat',
              encode: true,
            }),
        },
      },
    }),
  ...options,
});

export const useGetAssignedDocumentList = (
  params: DocumentsListParams,
  options?: UseQueryOptions<DocumentResponse>,
) => {
  const { message } = App.useApp();

  return useQuery<DocumentResponse, Error>(
    getUsersQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);
        message.error(uiMessage);
      },
      ...options,
    }),
  );
};
